<template>
    <div class="my-2">
        <v-toolbar flat color="white" min-width="800px">
            <v-layout justify-center align-center>
                <v-flex xs4 mx-1>
                    <h3 class="title grey--text">No. Of Networks: {{networks.length}}</h3>
                </v-flex>
                <v-flex xs4 mx-1>
                    <h3 class="title grey--text">Units: {{networks.reduce((a, b) => +a + +b.locationNetwork.numberOfUnits, 0)}}</h3>
                </v-flex>
            </v-layout>
        </v-toolbar>
        <v-data-table :items="networks" :headers="headers" :rows-per-page-items="[250]">
             <template v-slot:items="props">
                 <td class="text-xs-center">
                     {{props.item.locationNetwork.name}}
                 </td>
                 <td class="text-xs-center" v-if="props.item.locationNetwork.region">
                     {{props.item.locationNetwork.region.name}}
                 </td>
                 <td v-else></td>
                  <td
          v-if="props.item.locationNetwork.networkStatus==='Live'"
          class="text-xs-center"
        >
          <v-chip small class="white--text" color="light-green">Live</v-chip>
        </td>
        <td
          v-if="props.item.locationNetwork.networkStatus==='In Progress'"
          class="text-xs-center"
        >
          <v-chip small class="white--text" color="blue">In Progress</v-chip>
        </td>
        <td
          v-if="props.item.locationNetwork.networkStatus==='Planned'"
          class="text-xs-center"
        >
          <v-chip small class="white--text" color="orange">Planned</v-chip>
        </td>
                  <td class="text-xs-center">
                     {{props.item.locationNetwork.backhaulType}}
                 </td>
                  <td class="text-xs-center">
                     {{props.item.locationNetwork.numberOfUnits}}
                 </td>

             </template>
        </v-data-table>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            networks: [],
            headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Region",
          align: "center",
          value: "locationNetwork.region.name"
        },
        {
          text: "Network Status",
          align: "center",
          value: "locationNetwork.networkStatus"
        },
        {
          text: "Backhaul Type",
          align: "center",
          value: "locationNetwork.backhaulType"
        },
        {
          text: "No. Of Units",
          align: "center",
          value: "locationNetwork.numberOfUnits"
        }        
            ]
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize(){
            this.getFnoNetworks()
        },
        getFnoNetworks(){
            Api().get('/virtualFnoPackageLocationNetwork').then(response=>{
                this.networks = response.data
                console.log(this.networks)
            })
        }
    }
}
</script>